module.exports = __webpack_public_path__ + "img/44.385bf9f6.jpg";